import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as sessionActions from "../../redux/VinLookup/action";

// import VinList from "../../components/VinModerationListing";
import VinModerationListing from "../../components/VinModerationListing";
import VinDetailPopup from "../../components/VinModerationDetailPopup";
import VinLookup from "../../components/VinLookup";

class Vin extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  fetchTransferModerationListing = (data) => {
    this.props.actions.fetchTransferModerationListing(data);
  };

  fetchTransferModerationDetailListing = (data) => {
    this.props.actions.fetchTransferModerationDetailListing(data);
  };

  moderationTransfer = (data) => {
    this.props.actions.moderationTransfer(data);
  };

  fetchVinLookup = (data) => {
    this.props.actions.fetchVinLookup(data);
  };

  fetchAllUser = (data) => {
    this.props.actions.fetchAllUser(data);
  };

  changeOwnershipTransfer = (data) => {
    this.props.actions.changeOwnershipTransfer(data);
  };

  uploadUrl = (data) => {
    this.props.actions.uploadUrl(data);
  };

  clearReducer = () => {
    this.props.actions.clearReducer();
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "moderation":
        return (
          <VinModerationListing
            fetchTransferModerationListing={this.fetchTransferModerationListing}
            fetchTransferModerationDetailListing={
              this.fetchTransferModerationDetailListing
            }
            moderationTransfer={this.moderationTransfer}
            transferModerationListing={this.props.transferModerationListing}
            transferModerationListingStatus={
              this.props.transferModerationListingStatus
            }
            elements={this.props.elements}
            transferModeration={this.props.transferModeration}
            transferModerationCount={this.props.transferModerationCount}
            transferModerationStatus={this.props.transferModerationStatus}
            transferModerationDetailListing={
              this.props.transferModerationDetailListing
            }
            transferModerationDetailListingStatus={
              this.props.transferModerationDetailListingStatus
            }
          />
        );

      case "lookup":
        return (
          <VinLookup
            fetchVinLookup={this.fetchVinLookup}
            fetchAllUser={this.fetchAllUser}
            changeOwnershipTransfer={this.changeOwnershipTransfer}
            clearReducer={this.clearReducer}
            elements={this.props.elements}
            vinLookupStatus={this.props.vinLookupStatus}
            vinLookup={this.props.vinLookup}
            allUser={this.props.allUser}
            allUserStatus={this.props.allUserStatus}
            ownershipTransfer={this.props.ownershipTransfer}
            ownershipTransferStatus={this.props.ownershipTransferStatus}
            uploadUrl={this.uploadUrl}
            documentRead={this.props.documentRead}
          />
        );
      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    elements: state.Elements.elements,
    transferModerationListingStatus:
      state.VinLookup.transferModerationListingStatus,
    transferModerationListing: state.VinLookup.transferModerationListing,
    vinLookupStatus: state.VinLookup.vinLookupStatus,
    vinLookup: state.VinLookup.vinLookup,
    allUser: state.VinLookup.allUser,
    allUserStatus: state.VinLookup.allUserStatus,
    ownershipTransfer: state.VinLookup.ownershipTransfer,
    ownershipTransferStatus: state.VinLookup.ownershipTransferStatus,
    transferModerationStatus: state.VinLookup.transferModerationStatus,
    transferModeration: state.VinLookup.transferModeration,
    transferModerationCount: state.VinLookup.transferModerationCount,
    documentRead: state.VinLookup.documentRead,
    transferModerationDetailListing:
      state.VinLookup.transferModerationDetailListing,
    transferModerationDetailListingStatus:
      state.VinLookup.transferModerationDetailListingStatus,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Vin));
